import React from 'react';
import { Grid, Typography } from '@material-ui/core';

import ErrorAnalysisStrokeTypeInfluenceChartView from '../../common/ErrorAnalysisStrokeTypeInfluenceChartView';
import ErrorAnalysisForCharactersChartView from './ErrorAnalysisForCharactersChartView';
import useReportQueryParams from '../../../../hooks/use-report-query-params';
import ErrorAnalysisForCharactersTableView from './ErrorAnalysisForCharactersTableView';
import Popover from 'components/@common/Popover';
import ErrorTypeHelpInfo from '../../common/ErrorTypeHelpInfo';
import { ModuleType, ReportView } from '../../../../types';
import { useTranslation } from 'react-i18next';

const StudentErrorAnalysisCards: React.FC = () => {
  const [{ viewAs }] = useReportQueryParams();
  const { t } = useTranslation('Reports');

  const chartView = (
    <>
      <ErrorAnalysisForCharactersChartView module={ModuleType.CAPITALS} />
      <ErrorAnalysisForCharactersChartView module={ModuleType.LOWERCASE} />
      <ErrorAnalysisForCharactersChartView module={ModuleType.NUMBERS} />
      <Grid item xs={6} lg={3}>
        <ErrorAnalysisStrokeTypeInfluenceChartView />
      </Grid>
    </>
  );

  const tableView = (
    <>
      <ErrorAnalysisForCharactersTableView module={ModuleType.CAPITALS} />
      <ErrorAnalysisForCharactersTableView module={ModuleType.LOWERCASE} />
      <ErrorAnalysisForCharactersTableView module={ModuleType.NUMBERS} />
    </>
  );

  const REPORT_VIEW_MAP: { [key in ReportView]?: any } = {
    [ReportView.CHART]: chartView,
    [ReportView.TABLE]: tableView
  };

  return (
    <section>
      <Popover description={<ErrorTypeHelpInfo />}>
        <Typography variant="h3">{t('Error Analysis')}</Typography>
      </Popover>
      {REPORT_VIEW_MAP[viewAs]}
    </section>
  );
};

export default React.memo(StudentErrorAnalysisCards);
